import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import {INote} from '../models/avis.model';
import {Note} from '../models/NotePost';

@Injectable({
  providedIn: 'root'
})

export class NoteService {

  constructor(private http: HttpClient) {}

  // <!-- =================================================================-->
  // <!-- 🌴🌴🌴🌴🌴🌴🌴🌴🌴🌹🌹🌹  For Achats 🌹🌹🌹🌴🌴🌴🌴🌴🌴🌴🌴🌴  -->
  // <!-- ================================================================ -->

  query(): Observable<any> {
    return this.http.get<any>(`${environment.url}/notePost`);
  }

  loadNoteSeller():Observable<any> {
    return this.http.get<any>(`${environment.url}/v1/noteSeller`);
  }

  loadNotePoste():Observable<any> {
    return this.http.get<any>(`${environment.url}/v1/notePost`);
  }

  getNoteBycurrentSearch(search: string, page: number, size: number) {
    return this.http.get<any>(`${environment.url}/notePost` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size));
  }

  findNotesByIdPost(idPost: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/notePost/` + idPost, {'headers': headers});
  }

  getNotesByIdPost(idPost: number) {
    return this.http.get<any>(`${environment.url}/notePost/bypost/` + idPost);
  }

  getNoteById(idNote: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/notePost/` + idNote, {'headers': headers});
  }

  getIPostById(idPost: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/post/` + idPost, {'headers': headers});
  }

  saveNote(note: INote) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/notePost`, note, {'headers': headers});
  }

  setOrderItemToNoted(idOrderItem: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/order_item/noted/` + idOrderItem, {'headers': headers});
  }

  // touts les achats déjà notés par user connecté
  achatsDejaNoter() {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/notePost/connected`, {'headers': headers});
  }

  // Modifie une note spécifique
  updateNote(note: INote) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/notePost/` + note.id, note, {'headers': headers});
  }

  // Supprime une note spécifique
  deleteNote(idNote: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/notePost/` + idNote, {'headers': headers});
  }

  // toutes les notes que les users m'ont noté en tant que vendeur
  notesForMe(): Observable<Note> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/noteSeller/noteForMe`, {'headers': headers});
  }

  // toutes les notes que les users ont fait sur mes ventes
  notesForMeVentes(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/notePost/seller`, {'headers': headers});
  }

  // toutes les notes que je fais sur mes vendeurs
  myNotes(): Observable<Note> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/noteSeller/myNote`, {'headers': headers});
  }

  // Recupre les notes qu'on lui a attrubuées (Le vendeur) =>(sans connexion du vendeur).
  // Cette methode est utilisée au niveau des details lorsqu'on va cliquer sur le nom du vendeur pr aff ces notes
  getNotesAttribuateToThisSeller(idVendeur: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/v1/noteSeller/byuser/` + idVendeur, {'headers': headers});
  }

  // les notes le vendeur connecte
  // getNotesdVendeurConnected(idUserConnected)
  // {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
  //   return this.http.get(`${environment.url}/noteSeller/byuser/`+idUserConnected,{'headers': headers});
  // }

  // k jai noter au autres vendeurs (je suis vendeur)
  getVendeurById(idVendeur: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/user/` + idVendeur, {'headers': headers});
  }

  saveNoteVendeur(note: INote) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/noteSeller`, note, {'headers': headers});
  }

  updateNoteVendeur(note: INote) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/noteSeller/` + note.id, note, {'headers': headers});
  }

  deleteNoteVendeur(idNote: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/noteSeller/` + idNote, {'headers': headers});
  }


  // ------------------------------- For Diagram ------------------------------------------
  getHistoNotesKiMeSontAttr(year: any = new Date().getFullYear()) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/noteSeller/byMonthAndYear/` + year , {'headers': headers});
  }

  getHistoNotesAttrAMesVentes(year: any = new Date().getFullYear()) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/notePost/byMonthAndYear/` + year , {'headers': headers});
  }

  // getHistoNotesKiMeSontAttr(date:string = '')
  // {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
  //   return this.http.get(`${environment.url}/noteSeller/byMonth/`+date , {'headers': headers});
  // }

  // getHistoNotesAttrAMesVentes(date:string = '')
  // {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
  //   return this.http.get(`${environment.url}/notePost/byMonth/`+date , {'headers': headers});
  // }
}
